/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";

//Redux
import { useSelector, useDispatch } from "react-redux";

// Custom methods
import { isNumber } from "../../../../../../Libs/CustomMethods/customMethods";

// actions
import { vgRemoveMessage } from "../../../../../../store/signalr/actions";
import {
  removeMessage,
  updateUnreadMsg,
  saveScroll,
} from "../../../../../../store/operator/actions";

import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

// Components
import ScrollIcon from "../scrollIcon/scrollIcon";

//i18n
import { withTranslation } from "react-i18next";

// Theme style
import "./lightTheme.scss";
import { sendStatus } from "../../../../../../store/sendStatus/actions";

const importDarkMode = (mainTheme) => {
  if (mainTheme === "dark") {
    require("./darkTheme.scss");
  }
};

const ChatArea = ({ showMessages, chatId, scrollToBottom }) => {
  const { mainTheme } = useSelector((state) => state.Layout);
  const { messageOperator } = useSelector((state) => state.Operator);

  const dispatch = useDispatch();

  importDarkMode(mainTheme);

  const prevScrolls = useRef({});
  const [isScrollable, setIsScrollable] = useState(false);

  // TODO: improve these methods with ref
  const getScrollArea = () => {
    return document.getElementById("updatescroll");
  };
  const getUnreadEl = () => {
    return document.getElementById("unreadMsg");
  };

  const setScrollPos = (pos) => {
    let element = getScrollArea();
    if (element) {
      element.scrollTop = pos;
    }
  };

  const handleScrollBottom = () => {
    let element = getScrollArea();
    let unreadEl = getUnreadEl();

    if (element && chatId) {
      if (unreadEl) {
        let position = unreadEl.offsetTop - element.offsetTop;
        setScrollPos(position);
      } else {
        let position = element?.scrollHeight;
        setScrollPos(position);
      }
    }
  };

  const clearMsgs = () => {
    let status = "read";
    let unreadEl = getUnreadEl();
    dispatch(vgRemoveMessage(chatId));

    let chat = messageOperator?.chats?.data?.find((e) => {
      return e?.conversationId === chatId;
    });

    if (chat) {
      let pos = messageOperator?.chats?.data?.indexOf(chat);

      if (unreadEl) {
        setTimeout(
          () => dispatch(removeMessage({ chatId: chatId, pos: pos })),
          1000
        );
      }

      dispatch(
        updateUnreadMsg({ chatId: chatId, pos: pos, unreadMessages: 0 })
      );
    }

    dispatch(sendStatus({ chatId, status }));
  };

  const handleScroll = (value) => {
    let prev = prevScrolls?.current;
    if (chatId && value !== prev[chatId]) {
      prev[chatId] = value;
    }
  };
  useEffect(() => {
    let position = messageOperator?.chats_scroll_text?.[chatId]?.scrollPos ?? 0;
    setScrollPos(position);

    return () => {
      let prev = prevScrolls?.current;
      if (chatId && isNumber(prev[chatId])) {
        position !== prev[chatId] && dispatch(saveScroll(chatId, prev[chatId]));
      }
    };
  }, [chatId]);

  useEffect(() => {
    let element = getScrollArea();
    if (element && element.scrollHeight > element.offsetHeight) {
      setIsScrollable(true);
    } else {
      setIsScrollable(false);
    }
  }, [showMessages]);

  useEffect(() => {
    if (scrollToBottom) {
      setTimeout(() => {
        handleScrollBottom();
        clearMsgs();
      }, 200);
    }
  }, [scrollToBottom]);

  return (
    <>
      <PerfectScrollbar
        id="updatescroll"
        onScroll={(e) => handleScroll(e.target.scrollTop)}
      >
        <ul className={`list-unstyled ${isScrollable ? "pr-3" : ""}`}>
          {showMessages}
        </ul>

        <ScrollIcon
          qnt={
            messageOperator?.chats?.data?.find(
              (e) => e.conversationId === chatId
            )?.unreadMessages
          }
          onClick={() => {
            handleScrollBottom();
            clearMsgs();
          }}
          isScrollable={isScrollable}
        />
      </PerfectScrollbar>
    </>
  );
};
export default withTranslation()(ChatArea);
